import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  Optional,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import {fromEvent, Subscription} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import {BrowserService} from '@services/components/browser.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit, OnDestroy {
  @ViewChild('mainComponent') mainComponent!: ElementRef;
  isMobile: boolean | null = null;
  scrolled = false;
  isBrowser = false;

  private resizeSub!: Subscription;
  private lastDeviceType: 'mobile' | 'tablet' | 'desktop' | null = null;

  constructor(
    private browserService: BrowserService,
    @Optional() @Inject(PLATFORM_ID) platformId: Object,
    private router: Router
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngAfterViewInit(): void {
    if (!this.isBrowser) return;

    this.updateDeviceType();

    this.resizeSub = fromEvent(window, 'resize')
      .pipe(debounceTime(300))
      .subscribe(() => {
        const newType = this.getDeviceType();

        if (newType !== this.lastDeviceType) {
          location.reload();
        }
      });
  }

  onScroll(event: any): void {
    const scrollTop = event.target.scrollTop;
    this.scrolled = scrollTop >= 48;
  }

  private updateDeviceType(): void {
    this.lastDeviceType = this.getDeviceType();
    this.isMobile = this.lastDeviceType === 'mobile';
  }

  private getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
    const width = window.innerWidth;
    if (width < 768) return 'mobile';
    if (width < 1440) return 'tablet';
    return 'desktop';
  }

  ngOnDestroy(): void {
    this.resizeSub?.unsubscribe();
  }
}
